import VatRates from "./VatRates"

export default VatRates
